import React from "react";
import { useRouteLoaderData } from "react-router-dom";

import EventPageIndex from "./apella/EventPage";
import NotFound from "./components/NotFound";

const EventPage = () => {
    const { eventData } = useRouteLoaderData("eventpage") as any;
    
    const canView = Object.keys(eventData).length > 0 && eventData.event?.publish;

    if (canView) {
        return <EventPageIndex eventData={eventData} />
    } else {
        return <NotFound />
    }
}


export default EventPage;